/** */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MemberAreaHeader from './header/header';
import GMDashboard from './dashboard';
import Organizations from './organizations/_index';
import Billing from './billing';
import { BubbleDisplayProvider } from 'contexts/bubble';
import { BubbleDisplay } from 'app/shared/bubble-display';

export const ModuleLayout = ({ setOpenMenuTray }) => {
  return (
    <BubbleDisplayProvider>
      <section className="app-content">
        <>
          <MemberAreaHeader onHamburgerClick={() => setOpenMenuTray(true)} />
          <Routes>
            <Route path="/organizations/*" element={<Organizations />} />
            <Route path="/billing/*" element={<Billing />} />
            <Route path="/*" element={<GMDashboard />} />
          </Routes>
        </>
      </section>
      <BubbleDisplay />
    </BubbleDisplayProvider>
  );
};
